import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PeoplesRoutingModule } from './peoples-routing.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PeoplesRoutingModule
  ]
})
export class PeoplesModule { }
